export const pictureParamsData = [
  {
    tag: 'F1',
    left: 10.3,
    top: 7.84,
    width: 56.35,
    height: 39.3,
  },
  {
    tag: 'F2',
    left: 76.67,
    top: 12.5,
    width: 39.9,
    height: 27.7,
  },
  {
    tag: 'F3',
    left: 9.79,
    top: 58.84,
    width: 32.08,
    height: 32.1,
    borderRadius: '50%',
  },
  {
    tag: 'F4',
    left: 49.4,
    top: 55.31,
    width: 41.4,
    height: 28.1,
  },
  {
    tag: 'F5',
    left: 101.04,
    top: 50.44,
    width: 28.6,
    height: 43.3,
  },
  {
    tag: 'F6',
    left: 138.2,
    top: 61.98,
    width: 51.56,
    height: 36.4,
  },
];
